import React from 'react';
import { useModal } from '../context/ModalContext';
import { useTranslation } from 'react-i18next';
import './GlobalModal.css';

const GlobalModal: React.FC = () => {
    const { isOpen, type, title, message, closeModal, confirmAction } = useModal();
    const { t } = useTranslation();

    if (!isOpen) return null;

    return (
        <div className="global-modal-overlay" onClick={closeModal}>
            <div className="global-modal-content" onClick={e => e.stopPropagation()}>
                <div className="global-modal-header">
                    <h3>{title}</h3>
                </div>
                <div className="global-modal-body">
                    <p>{message}</p>
                </div>
                <div className="global-modal-footer">
                    {type === 'confirm' && (
                        <button className="btn-modal-secondary" onClick={closeModal}>
                            {t('common.cancel')}
                        </button>
                    )}
                    <button
                        className={type === 'confirm' ? "btn-modal-danger" : "btn-modal-primary"}
                        onClick={type === 'confirm' ? confirmAction : closeModal}
                    >
                        {type === 'confirm' ? t('common.yes') : t('common.close')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GlobalModal;
